<template>
<!-- <div class="login" v-if="!(this.$parent.user && !this.$parent.user.isAnonymous)"> -->
<div class="login">
    <div>
    
        <section id="firebaseui-auth-container" v-bind:class="!(user && !user.isAnonymous) ? '' : 'hidden'"></section>

        <div v-if="user && !user.isAnonymous">Logged in as {{user.displayName}} <a @click="signOut">Sign out</a></div>
        <!-- <pre>{{user}}</pre> -->
    </div>
        <!-- <div class="card-content" v-if="user && !user.isAnonymous">
         <p>You are signed in as <strong>{{user.displayName}}</strong>  </p>
        </div> -->
</div>
</template>

<script>


import firebase from "firebase";
import * as firebaseui from "firebaseui";
// import {config} from '../helpers/firebaseConfig';
import "firebaseui/dist/firebaseui.css";
// import {auth, googleProvider, emailProvider} from '../../back/firebase/firebase';

export default {
    name:"Login",
    computed: {
        user: function() {
            return this.$getParent('App').user;
            // return this.$firebase.auth().currentUser;
        }
    },
    data: function() {
      // console.log("hi");
            return {
                // user: null
            }
    },
    methods: {
        signOut() {
            firebase.auth().signOut().then(function() {
            // Sign-out successful.
                location.reload();
            }).catch(function(error) {
            // An error happened.
            });
        }
    },
    created() {
    //    firebase.auth().onAuthStateChanged(user => {
    //        if (user) {
    //            this.user = user;
    //        }
    //    });
   },
    mounted() {
        // let fb = this.$firebase;
        console.log("login mounted");
        let ui = firebaseui.auth.AuthUI.getInstance();
        if (!ui) {
            ui = new firebaseui.auth.AuthUI(firebase.auth());
        }
        var that = this;
        var userobj = this.$getParent('App').user;
        // this.user = this.$getParent('App').user;
        var uiConfig = {
            callbacks: {
                signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                    console.log("signed in");
                // User successfully signed in.
                    // Return type determines whether we continue the redirect automatically
                    // or whether we leave that to developer to handle.
                   
                    // that.$getParent('App').user = authResult;
                    userobj = authResult;
                    console.log(authResult);
                    // console.log("Signed in " + authResult.user.email);
                    // that.$writeDoc("users", authResult.user.uid, { 
                    //     uid: authResult.user.uid,
                    //     name: authResult.user.providerData[0].displayName,
                    //     email: authResult.user.email,
                    //     photoUrl: authResult.user.providerData[0].photoURL,
                    //     provider: authResult.user.providerData[0].providerId
                    // }, true);
                    that.$parent.showModal = false;
                    // that.$parent.hide();
                    location.reload();
                    return false;
                },
                signInFailure: function(error) {
                    // For merge conflicts, the error.code will be
                    // 'firebaseui/anonymous-upgrade-merge-conflict'.
                    if (error.code != 'firebaseui/anonymous-upgrade-merge-conflict') {
                        return Promise.resolve();
                    }
                    // The credential the user tried to sign in with.
                    var cred = error.credential;
                    // Copy data from anonymous user to permanent user and delete anonymous
                    // user.
                    // ... https://github.com/firebase/firebaseui-web/blob/master/README.md
                    // Finish sign-in after data is copied.
                    console.log("Resolved anon merge conflict");
                    console.log(cred);
                    that.$parent.isLoginModalActive = false;
                    return firebase.auth().signInWithCredential(cred);
                }
            },
            autoUpgradeAnonymousUsers: true,
            // signInSuccessUrl: "/",
            signInFlow: "popup",
            signInOptions: [
                
                { provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID, requireDisplayName: false} 
                
                ],
            
            // privacyPolicyUrl: 'https://isolatingtogether.com/privacy'
        };
        // if (ui.isPendingRedirect()) {
            ui.start('#firebaseui-auth-container', uiConfig);
        // }        // this.$getParent('App').user;
    },

}
</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/Login.vue